export default __webpack_public_path__ + "static/media/youtube-icon.5742ac29.svg";